import  axios from 'axios'
import { Message,MessageBox} from 'element-ui'
import store from '../store';

let servie = axios.create({
    // baseURL: process.env.NODE_ENV === 'production' ? `/` : '/build',
    baseURL: process.env.BASE_URL, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 32000 // set to >30s to catch send email timeout errors
});
let route = '';
servie.interceptors.request.use(config => {
    // // /判断请求的是登录还是其他的地址
    // 返回处理过的axios设置
    // if(config.url.indexOf('/login')!=-1){
    //     //登录接口,不做token信息添加
    // }else{
    //     //非登录接口,为了一些权限接口,做token信息添加
    //     config.headers.Authorization = window.sessionStorage.getItem('token');
    // }
    if(config.url.indexOf('/animal')!=-1){
        //登录接口,不做token信息添加
        config.headers.Accept='application/prs.wenno.v1+json';
    }else if(config.url.indexOf('/hologram')!=-1){
        //登录接口,不做token信息添加
        config.headers.Accept='application/prs.wenno.v3+json';
    }else{
        //非登录接口,为了一些权限接口,做token信息添加
        config.headers.Accept='application/prs.wenno.v2+json';
    }
    // let lang = sessionStorage.getItem('language');
    // let lang = sessionStorage.getItem('lang');
    let lang = store.state.language;
    if(lang=='zh-CN'){
        lang = 'zh-CN';
    }else if(lang=='zh-TW'){
        lang = 'zh-TW'
    }else{
        lang = 'en';
    }
    config.headers['Accept-Language']=lang;

    route = config.url;
    // config.headers['Accept-Language']=store.state.language;
    if(config.url != "/api/send_verify_code"){
        config.headers['Accept-region']=store.state.ccode;
    }


    return config;
},error => {
    Promise.reject(error)
});
servie.interceptors.response.use(
    response => {
        // console.log(response);
        // console.log(response.status);
        if(response.status==200||response.status==201||response.status==203||response.status==204){
            return response.data;
        }else{
            Message({
                message: 'Request failed!',
                type: 'error',
                duration:1800,
                offset:200,
            });
        }
    },
    error => {
        console.log(error);
        if(error.response.data.errors){
            return Promise.reject(error);
        }else if(error.response.data.message){
            if(route.indexOf('/authorizations')!=-1){
                Message({
                    message:error.response.data.message,
                    type: 'error',
                    duration:1800,
                    offset:200,
                });
            }else if(error.response.data.status_code==401&&localStorage.token){
                store.commit('refreshToken');
            // }else if(error.response.data.status_code==500){
                // localStorage.clear();
                // store.commit('resetUser');
                // store.commit('resetCartList');
                // setTimeout(function(){
                //     store.state.isLoginShow = true;
                // },1000);
            }else{
                Message({
                    message:error.response.data.message,
                    type: 'error',
                    duration:1800,
                    offset:200,
                });
            }
        }else{
            Message({
                message: 'Request failed!',
                type: 'error',
                duration:1800,
                offset:200,
            });
        }
        return Promise.reject(error)
    }
)
export default  servie; ///　 一定要记得导出



// WEBPACK FOOTER //
// ./src/http/index.js